/**
 * Shared dimensions for B2B registration field controls (Figma).
 * Width uses `maxW` so fields stay responsive below 512px viewports.
 */
export const B2B_FIELD_CONTROL_MAX_WIDTH = '512px';
export const B2B_FIELD_CONTROL_HEIGHT_PX = '64px';
export const B2B_FIELD_CONTROL_PADDING_X = '16px';
/** Space between label and control stack */
export const B2B_FIELD_LABEL_TO_CONTROL_GAP = '10px';
export const B2B_FIELD_CONTROL_BORDER_RADIUS = '16px';
export const B2B_FIELD_CONTROL_BORDER_WIDTH = '1px';

/** Vertical padding so 64px total height fits ~md line-height with 1px border (border-box). */
export const B2B_FIELD_CONTROL_PADDING_Y = '21px';

/** B2B multiline fields — description, previous events, etc. (Figma). */
export const B2B_FIELD_TEXTAREA_MAX_WIDTH = '1056px';
export const B2B_FIELD_TEXTAREA_MIN_HEIGHT = '195px';
export const B2B_FIELD_TEXTAREA_PADDING = '16px';
